import { 
  getEquipments,
  getGpsGateMainUsers,
  getGpsGateBackupUsers,
  getLastReview
} from "../../../services/equipmentsAPI"

import moment from "moment-timezone";



function findEquipmentByName(equipment_name, equipments) {
  // console.log("equipment name search", equipment_name)
  return equipments.find(e => e.equipment_name === String(equipment_name)) || null;
}

function findEquipmentByUserName(user_name, equipments) {
  // console.log("equipment name search", equipment_name)
  return equipments.find(e => e.user_name === String(user_name)) || null;
}


export async function equipmentHealthTableInitializer () {

  try {

    let equipment_table_data = []

    const equipments = await getEquipments()
    if(!equipments?.success) console.log('Error fetching main devices from gps gate', equipments.mesagge)
    
    // console.log('data base equipments', equipments)


    const main_users = await getGpsGateMainUsers();
    if(!main_users?.success) console.log('Error fetching main devices from gps gate', main_users.mesagge)
    
    // console.log('main devices', main_users)

    const backup_users = await getGpsGateBackupUsers();
    if(!backup_users?.success) console.log('Error fetching main devices from gps gate', backup_users.mesagge)

    // console.log('backup devices', backup_users)

    const last_review = await getLastReview();
    if(!last_review?.success) console.log('Error fetching last review', last_review.mesagge)

    console.log('last review', last_review)

    main_users.data.map(main_user => {
      // console.log('main user data', main_user)

      const equipment_data = findEquipmentByName(main_user.name, equipments.data)
      const last_review_data = findEquipmentByUserName(main_user.username, last_review.data)

      const device_data = {
        equipment_name: main_user.name,
        user_name: main_user.username,
        time_category_name: equipment_data?.time_category_name || "not available",
        equipment_id: equipment_data?.equipment_id || "not available",
        main: true,
        last_connection: main_user.deviceActivity,
        last_seen: main_user.trackPoint.utc,
        gps_status: last_review_data?.gps_status || 'Not reviewed',
        cellular_status: last_review_data?.cellular_status || 'Not reviewed',
        box_status: last_review_data?.box_status || 'Not reviewed',
        obs:  last_review_data?.obs || '',
        last_reviewed: last_review_data?.last_review ? moment.utc(last_review_data.last_review).format("HH:mm:ss, DD-MM-YYYY") : '',
      }

      equipment_table_data.push(device_data)

    })

    backup_users.data.map(backup_user => {

      let main_name = backup_user.name.split('-')[0]

      const equipment_data = findEquipmentByName(main_name, equipments.data)
      const last_review_data = findEquipmentByUserName(backup_user.username, last_review.data)

      const device_data = {
        equipment_name: main_name,
        user_name: backup_user.username,
        time_category_name: equipment_data?.time_category_name || "not available",
        equipment_id: equipment_data?.equipment_id || "not available",
        main: false,
        last_connection: backup_user.deviceActivity,
        last_seen: backup_user.trackPoint.utc,
        gps_status: last_review_data?.gps_status || 'Not reviewed',
        cellular_status: last_review_data?.cellular_status || 'Not reviewed',
        box_status: last_review_data?.box_status || 'Not reviewed',
        obs:  last_review_data?.obs || '',
        last_reviewed: last_review_data?.last_review ? moment.utc(last_review_data.last_review).format("HH:mm:ss, DD-MM-YYYY") : '',
      }

      equipment_table_data.push(device_data)

    })

    console.log('device object filtered ', equipment_table_data)

    return equipment_table_data

  } catch (error) {
    console.log('Error fetching data for equipments health table', error)
  }


  return 
}
